import { jsx as a, jsxs as n } from "react/jsx-runtime";
import { W as f, X as p } from "../../vendor-Dd6qj6gJ.js";
import { c as t } from "../../styles.module-BF2N4g8-.js";
import { Pagination as b } from "./Pagination.js";
import { Toolbar as u } from "./Toolbar.js";
import { TableContextProvider as $ } from "./tableContext.js";
import { useRef as v } from "react";
import { useStickyHeader as x } from "./useStickyHeader.js";
import "../../theme/spacing.js";
import { omitStyleRenderProps as h } from "../../utils/omitStyleRenderProps/index.js";
function N({
  columnResizable: l,
  toolbar: e,
  pagination: r,
  isLoading: m = !1,
  children: d,
  scrollRoot: s,
  ...o
}) {
  const i = v(null), c = l ? f : "div";
  return x(i, s), /* @__PURE__ */ a($, { value: { isLoading: m }, children: /* @__PURE__ */ n(c, { className: t.tableContainer, children: [
    e && /* @__PURE__ */ a(u, { "aria-label": `${o["aria-label"]} controls`, children: e() }),
    /* @__PURE__ */ a("div", { className: t.tableScrollContainer, children: /* @__PURE__ */ a(
      p,
      {
        ...h(o),
        className: t.table,
        "data-paginated": r ? !0 : void 0,
        "data-toolbar": e ? !0 : void 0,
        ref: i,
        children: d
      }
    ) }),
    r && /* @__PURE__ */ a(b, { ...r, "aria-label": `${o["aria-label"]} pagination` })
  ] }) });
}
N.displayName = "Table";
export {
  N as Table
};
